(ns hypnos.dme.tile.referral
  "Referral tiles."
  (:require [clojure.string :as str]
            [hypnos.dme.subs]
            [hypnos.dme.tile.field.referral-ahi :as referral-ahi]
            [hypnos.dme.tile.field.referral-code :as referral-code]
            [hypnos.dme.tile.field.referral-contact :as referral-contact]
            ;; [hypnos.dme.tile.field.referral-dob :as referral-dob]
            [hypnos.dme.tile.field.referral-gender :as referral-gender]
            [hypnos.dme.tile.field.referral-key :as referral-key]
            [hypnos.dme.tile.field.referral-modality :as referral-modality]
            [hypnos.dme.tile.field.referral-name :as referral-name]
            [hypnos.dme.tile.field.referral-pressure :as referral-pressure]
            [hypnos.dme.tile.field.referral-therapist :as referral-therapist]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [hypnos.translator.patient :as t-p]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers


(defn- load
  [body]
  (let [loading? (rf/subscribe [:dme/gql-request-in-progress?])]
    (if @loading?
      [:div.card-content
       [:section.section
        [:div.content.has-text-grey.has-text-centered
         [:p
          [:span.icon.is-large
           [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
         [:p (tr :ui.label/loading)]]]]
      body)))

#_(defn- warning-notification
  "Show warning notification for new consults when the following citeria is met."
  [state]
  (let [modality (get-in @state [:patient :patient/last-consult :consult/modality :value])
        cpap     (get-in @state [:patient :patient/last-consult :consult/cpap :value])
        ipap     (get-in @state [:patient :patient/last-consult :consult/ipap :value])
        epap     (get-in @state [:patient :patient/last-consult :consult/epap :value])
        ahi      (get-in @state [:patient :patient/last-consult :consult/ahi :value])]
    (cond
      (or (nil? modality)
          (and (= :modality/cpap modality) (nil? cpap))
          (and (= :modality/bipap-vpap modality) (nil? ipap) (nil? epap)))
      [:article.message.is-warning [:div.message-body (tr :ui.warning/pressure)]]
      (and (= :modality/autopap-smartpap modality) (nil? ahi))
      [:article.message.is-warning [:div.message-body (tr :ui.warning/ahi)]])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Tile

(defn patient-tile
  [state]
  [:div.tile.is-ancestor
   [:div.tile.is-parent
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title (tr :ui.label/patient)]]
       (load
        [:div.card-content
         ;; referral code
         [referral-code/field state {:disabled (:referral-looked-up? @state)}]
         ;; patient info
         [referral-name/field state {:disabled true}]
         ;; [patient-dob/field state {:disabled (not edit-demographics?)}]
         [referral-gender/field state {:disabled true}]
         [referral-contact/contact-field state {:disabled true}]
         [referral-contact/alt-contact-field state {:disabled true}]])]]])

(defn referral-tile
  [state]
  (let [organization (rf/subscribe [:dme/organization])]
    [:div.tile.is-ancestor
     [:div.tile.is-parent
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title (tr :ui.label/referral)]]
       (load
        (let [disable (not (:referral-looked-up? @state))]
          [:div.card-content
           ;; patient info
           [referral-key/field state {:disabled disable}]
           [referral-therapist/field state {:disabled disable}]
           ;; clinical info
           #_[warning-notification state]
           [referral-ahi/field state {:disabled disable}]
           [referral-modality/field state {:disabled disable}]
           [referral-pressure/cpap-field state {:disabled disable}]
           [referral-pressure/ipap+epap-field state {:disabled disable}]
           [:div.field.is-horizontal
            [:div.field-label]
            [:div.field-body
             [:div.field
              [:div.field.is-grouped
               [:div.control
                [:a.button.is-info
                 {:href     (if (or disable
                                    (str/blank? (get-in @state [:patient :patient/key :value])))
                              ""
                              "/patient")
                  :disabled (or disable
                                (str/blank? (get-in @state [:patient :patient/key :value])))
                  :on-click (fn [_]
                              (when-not (or disable
                                            (str/blank? (get-in @state [:patient :patient/key :value])))
                                (let [org      (dissoc @organization :user/_organizations)
                                      referral (t-p/referral->db @state)
                                      patient  (-> referral
                                                   (dissoc :patient/last-consult)
                                                   (assoc :patient/organization org))
                                      consult  (:patient/last-consult referral)]
                                  ;; submit information
                                  (rf/dispatch-sync [:amplify/mutation
                                                     mutations/create-referral
                                                     {:patient (t-p/patient->gql patient)
                                                      :consult (t-p/consult->gql consult)}
                                                     :dme/set-patient
                                                     :dme/set-error]))))}
                 [:span (tr :ui.label/submit)]]]
               [:div.control
                [:a.button.is-info.is-outlined
                 {:href "/dashboard"}
                 [:span (tr :ui.label/cancel)]]]]]]]]))]]]))
